import Alpine from "alpinejs";

export default ({ productID }) => ({
	// STATE
	quantity: 1, // Default quantity
	productID, // Product ID passed to the component

	// LIFECYCLE
	init() {
		// Initialize the Alpine store if it doesn't already exist
		if (!Alpine.store("quote")) {
			Alpine.store("quote", {
				products: JSON.parse(localStorage.getItem("quoteProducts")) || [],

				addProduct(product) {
					const existingProduct = this.products.find(
						(p) => p.id === product.id
					);
					const qty = Number(product.quantity) || 1; // Ensure quantity is a number
					if (existingProduct) {
						existingProduct.quantity = qty;
					} else {
						this.products.push({
							...product,
							quantity: qty,
						});
					}
					this.saveToLocalStorage();
				},

				saveToLocalStorage() {
					localStorage.setItem("quoteProducts", JSON.stringify(this.products));
				},

				loadFromLocalStorage() {
					this.products =
						JSON.parse(localStorage.getItem("quoteProducts")) || [];
				},
			});
		}

		// Load products from localStorage into the store on page load
		Alpine.store("quote").loadFromLocalStorage();
	},

	// METHODS
	onAddProductToQuote() {
		const qty = Number(this.quantity) || 1;
		if (qty < 1) {
			return;
		}
		Alpine.store("quote").addProduct({
			id: this.productID,
			quantity: qty,
		});
	},
});
